// The inline message band above a form or list: an API refusal, a success
// confirmation, a warning. tone maps to the status colors. role defaults
// from the tone (bad is an alert, everything else a status) and can be
// overridden. Not for empty lists, which are EmptyState.

import './notice.css'

export function Notice({ tone = 'bad', role, className = '', children }) {
  return (
    <div
      className={`ui-notice ui-notice-${tone}${className ? ` ${className}` : ''}`}
      role={role ?? (tone === 'bad' ? 'alert' : 'status')}
    >
      {children}
    </div>
  )
}
